"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var ICVV =
/*#__PURE__*/
function () {
  /**
   * CVV constructor
   * @param {string} value
   */
  function ICVV(value) {
    (0, _classCallCheck2["default"])(this, ICVV);

    if (value instanceof ICVV) {
      this.value = value.value;
    } else {
      this.value = String(value).replace(/\s+/g, '');
    }

    if (!this.validate()) {
      this.value = '';
    }

    return this;
  }
  /**
   * @return {boolean}
   */


  (0, _createClass2["default"])(ICVV, [{
    key: "validate",
    value: function validate() {
      return /^[0-9]{3,4}$/.test(this.value);
    }
    /**
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.value || '';
    }
    /**
     * @param {string} value
     * @return {boolean}
     */

  }, {
    key: "is",
    value: function is(value) {
      return this.value === new ICVV(value).value;
    }
    /**
     * @return {string}
     */

  }, {
    key: "toHtml",
    value: function toHtml() {
      console.warn('ICVV prototype.toHtml() is deprecated. Use .toString().');
      return this.toString();
    }
  }]);
  return ICVV;
}();

var _default = ICVV;
exports["default"] = _default;